import axios from 'axios';
import { getApiKey } from './localStorage';
import { RESOURCE_TYPE } from './model';

const BRANDFOLDER_URL = 'https://brandfolder.com/api/v4';

export const getAssetsForContainer = (container, searchString) => {
  const path = container.type === RESOURCE_TYPE.Brandfolder ?
    `/brandfolders/${container.id}/assets` : `/collections/${container.id}/assets`;

  return axios
    .get(`${BRANDFOLDER_URL}/${path}`, {
      headers: {
        Authorization: `Bearer ${getApiKey()}`,
        'Content-Type': 'application/json'
      },
      params: {
        include: 'section',
        search: searchString
      }
    })
    .then(response => {
      return response.data.data.map(asset => ({
        id: asset.id,
        attributes: asset.attributes,
        section: asset.relationships.section.data
      }));
    });
};



// WEBPACK FOOTER //
// ./src/services/asset.js